module.exports = __webpack_public_path__ + "static/media/Sensitive-item.fec941a2.png";